import { SectionData } from "../_data/";

const HomeRoutes = [
  {
    path: "/",
    // name: SectionData.alias,
    routeAlias: SectionData.alias,
    title: "Quaese",
    components: {
      baseView: () =>
        import(/* webpackChunkName: "home" */ "../views/home.view.vue")
    },
    children: [
      {
        path: "",
        name: "competences",
        title: "Quaese",
        text: "Kompetenzen",
        components: {
          contentView: () =>
            import(
              /* webpackChunkName: "competences" */ "../components/competences.component.vue"
            )
        }
      },
      {
        path: "moreinfo",
        name: "moreinfo",
        title: "Timeline",
        text: "Timeline",
        components: {
          contentView: () =>
            import(
              /* webpackChunkName: "moreinfo" */ "../components/moreinfo.component.vue"
            )
        }
      },
      {
        path: "profile",
        name: "profile",
        title: "Steckbrief",
        text: "Steckbrief",
        components: {
          contentView: () =>
            import(
              /* webpackChunkName: "profile" */ "../components/profile.component.vue"
            )
        }
      }
    ]
  }
  // {
  //   path: "/highscorelist",
  //   name: "highscorelist-home",
  //   // route level code-splitting
  //   // this generates a separate chunk (highscorelist.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "highscorelist" */ "../views/home-home.view.vue")
  // },
  // {
  //   path: "/highscorelist/season/:seasonId/race/:id",
  //   name: "highscorelist-race",
  //   // route level code-splitting
  //   // this generates a separate chunk (highscorelist.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "highscorelist" */ "../views/home-race.view.vue")
  // },
  // {
  //   path: "/highscorelist/season/:id",
  //   name: "highscorelist-season",
  //   // route level code-splitting
  //   // this generates a separate chunk (highscorelist.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "highscorelist" */ "../views/home-season.view.vue")
  // }
];

export default HomeRoutes;
